import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  RespFont,
  TextArea,
} from "../common/Style";
import Switcher from "../common/switcher/Switcher";
import { destroyUser, editUserById } from "../../store/reducers/userReducer";
import { toast } from "react-toastify";
import YesNoModal from "../common/modals/YesNoModal";
import { CFV, getImageUrl } from "../common/others/Functions";
import GCalendar from "../common/calendar/Calendar";
import GenericModal from "../common/modals/GenericModal";
import OpacityLoading from "../common/loader/OpacityLoading";
import trash from "../../assets/common/trash.svg";
import call from "../../assets/common/call.svg";
import galleryWhite from "../../assets/common/galleryWhite.svg";
import notes from "../../assets/common/notes.svg";
import whatsappW from "../../assets/common/whatsappW.svg";
import tools from "../../assets/common/menu.svg";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Stats from "./Stats";
import { sendGenericSms } from "../../store/reducers/dataReducer";
import EditPics from "../common/others/EditPics";
import EditPicsAdmin from "../common/others/EditPicsAdmin";
import { edit } from "../../store/reducers/guestsReducer";
import FilterBar from "../common/others/FilterBar";

const EditGuest = ({ user, init }) => {
  const { isItay } = useSelector((state) => state.authReducer.user);
  const dispatch = useDispatch();
  const [editPic, setEditPic] = useState(false);
  const [ans, setAns] = useState("W");

  let categories = [
    { id: "W", name: "W" },
    { id: "M", name: "M" },
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    const body = {
      ...data,
      ans,
    };
    handleEdit(body);
    // dispatch(edit(user.key, body)).then((res) => {
    //   if (!res.payload?.error) {
    //     toast.success("הפעולה בוצעה בהצלחה");
    //     init();
    //   } else toast.error(res.payload?.error);
    // });
  };

  const handleEdit = (body) => {
    dispatch(edit(user.key, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        <FlexRowBetween>
          <div style={{ width: "65%" }}>
            <FilterBar
              color={"rgba(41,59,90,0.95)"}
              padding={"7px 12px"}
              data={categories}
              setProperty={setAns}
              property={ans}
            />
          </div>
          <div style={{ width: "30%" }}>
            <Label>אישרו</Label>
            <Input
              defaultValue={user.value.accept}
              type="number"
              step={1}
              {...register("accept", {
                required: false,
                min: 0,
                max: 100,
              })}
            />
            {CFV(`accept`, `מספר בין 0 ל 100`, errors)}
          </div>
        </FlexRowBetween>

        <Label>הערות</Label>
        <TextArea
          defaultValue={user.value.notes}
          type="text"
          rows="3"
          {...register("notes", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("notes", "עד 500 תווים", errors)}

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default EditGuest;
